var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZaSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_25623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 35.8412V9.17578L40.1459 22.5085L60.0088 35.8412H60Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4561 45.0075L24.1675 30.0137H-7.49006V44.9987H46.4561V45.0075Z",
    fill: "#0000CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8799 0.000120568H-7.49003V15.0115H24.1763C24.1763 15.0115 47.5898 -0.14929 47.8799 0.000120568Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 5.625V9.17571L40.1459 22.4996L60.0088 35.8412V39.3831L35.0044 22.5084L60.0088 5.625H60Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 5.62488V0H51.6506L25.1785 17.9293H-7.49856V27.0873H25.1785L51.6594 44.999H60V39.3829L35.0044 22.5083L59.9912 5.62488H60Z",
    fill: "#009933"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6592 0H46.4562L24.1676 15.0026H-7.48994V17.9293H25.1783L51.6592 0.00878888V0ZM51.6592 45.0078H46.4562L24.1676 30.014H-7.48994V27.0961H25.1783L51.6592 44.999V45.0078Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_25623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaSouthAfrica);
export default __webpack_public_path__ + "static/media/za South Africa.e6ebb6b66cb255574f2babdeb4385908.svg";
export { ForwardRef as ReactComponent };